// extracted by mini-css-extract-plugin
export default {"container":"jk-z","disabled":"kk-z","subtotal":"lk-z","legal":"mk-z"};